import type { Report } from "../generated/fresh-guard-api";

export const queryKeys = {
  users: {
    all: ["users"] as const,
    detail: (username: string | undefined) =>
      ["users", "detail", username ?? "no-username"] as const,
  },
  reporting: {
    allPaginated: (report: Report, page: number, limit: number) =>
      ["reporting", report, page, limit] as const,
  },
  markets: {
    all: ["markets"] as const,
  },
  marketComponents: {
    all: ["marketComponents"] as const,
    byMarket: (marketId?: string) =>
      ["marketComponents", "market", marketId] as const,
    forValidation: (marketId?: string) =>
      ["marketComponents", "forValidation", marketId] as const,
    detail: (id: string) =>
      ["marketComponents", "detail", id ?? "no-id"] as const,
  },
  version: {
    all: ["version"] as const,
  },
  userMarkets: {
    all: ["userMarkets"] as const,
    byUsername: (username?: string) =>
      ["userMarkets", "username", username] as const,
  },
  file: {
    byTargetAndName: (target?: string, filename?: string) =>
      ["file", target, filename] as const,
  },
  userProfile: ["userProfile"] as const,
  marketComponentTypes: {
    all: ["marketComponentTypes"] as const,
  },
  marketComponentArticleTypes: {
    all: ["marketComponentArticleTypes"] as const,
  },
  marketComponentHistory: {
    byMarketComponentId: (marketComponentId?: string, page?: number) =>
      ["marketComponentHistory", marketComponentId, page] as const,
    byMarketId: (marketId?: string, page?: number) =>
      ["marketComponentHistory", "byMarket", marketId, page] as const,
  },
};
